import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";
import { getBinaryFromFile } from 'utils/fileUtils';

export async function list({ query }) {
  const url = get_api_path("mastery/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(mastery_id) {
  const url = get_api_path("mastery/detail", {}, { mastery_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(mastery_id) {
  const url = get_api_path("mastery/delete", {}, { mastery_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(mastery_id, data) {
  const url = get_api_path("mastery/update", {}, { mastery_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("mastery/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function image(mastery_id, file) {
  const headers = { 'X-Name': file.name, 'Content-Type' : file.type };
  const data = await getBinaryFromFile(file);
  const url = get_api_path("mastery/image", {}, { mastery_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data, { headers });
  const { model } = response.data.result;
  return { model };
};

export async function reorder(data) {
  const url = get_api_path("mastery/reorder");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};